<div *ngIf="showControls" class="chart-top-controls">
    <div class="switcher-bar">
        <button *ngFor="let int of intervals"
                (click)="setChartInterval(int)"
                [class.active]="activeInterval === int"
                class="switch-btn">
            {{ int }}
        </button>
    </div>
</div>

<div class="market-chart-container">
    <div class="chart-relative-wrapper">
        <div #tooltip class="floating-tooltip"></div>
        <div #chartContainer class="chart-holder"></div>
    </div>
</div>